import {useQuery} from "react-query";
import {
    Certificate,
    Options,
    QueryListResult
} from "../utils/types";
import {getCertificates, getCompanyUserCertificates} from "../../../services/api/certificates";

export const COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY = "Q_COMPANY_USER_CERTIFICATES_ALL";
export type UseCertificatesOptions = Options;

export const useCompanyUserCertificates = (
    companyId: number,
    userId: number|undefined,
    options: UseCertificatesOptions = {}
) => {
    let {
        page,
        size,
        sort,
        include,
        ...rest
    } = options;

    if (!page) page = 0;
    if (!size) size = 50;
    if (!sort) sort = "-created_at";

    const filters = {
        "page[number]": page,
        "page[size]": size,
        sort,
        include,
        ...rest
    };

    return useQuery<QueryListResult<Certificate>>(
        [COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY, companyId, userId, page, size, sort, include],
        () => getCompanyUserCertificates(companyId, userId!, filters),
        {
            enabled: !!userId,
        }
    );
};
